import { useTranslation } from "react-i18next";
import image from '../../img/About/contact.png';
import Button from '../Button';

const Contact = () => {
    const { t } = useTranslation();
    return (
        <section className="relative open-sans pt-[90px] xl:pt-[160px]">
            <div className="relative z-10 max-w-[1220px] xl:mx-auto mx-[20px]">
                <div className="md:grid items-center flex flex-col grid-cols-2 gap-[50px] md:gap-[40px] xl:gap-[95px]">
                    <div>
                        <h2 className="text-[#0C2780] font-[700] text-[28px] xl:text-[45px]">
                            {t('about.contact.title')}
                        </h2>
                        <p className="mt-[25px] md:mt-[30px] max-w-[100%] md:max-w-[561px] sm:text-[16px] text-[14px] text-[#0C2780] font-[300]">
                            {t('about.contact.text_01')}
                        </p>
                        <p className="mt-[13px] md:mt-[15px] max-w-[100%] md:max-w-[561px] sm:text-[16px] text-[14px] text-[#0C2780] font-[300]">
                            {t('about.contact.text_02')}
                        </p>
                        <div className="hidden md:flex">
                            <Button className="mt-[40px]" color="#15318D" text="#EFEFEF" />
                        </div>
                    </div>
                    <div className="flex justify-center items-center">
                        <img className="w-[100%] md:max-w-[520px] sm:max-w-[340px] max-w-[330px]" src={image} alt='' />
                    </div>
                </div>
            </div>
        </section>
    )
};

export default Contact;
